import React from "react";
import { priceFormat } from "Utils/strings";
import { t } from "i18next";

const DailyMessagesPriceTable = ({ prices }) => {
  return (
    <table className="min-w-full border-collapse ">
      <thead className="">
        <tr>
          <th className="w-1/4"></th>
          {["Basic", "Professional", "Enterprise"].map((plan) => (
            <th className="border border-[--bg-d5] border-solid font-normal text-center bg-[--bg] w-1/4 py-2 px-4 text-sm">
              {plan}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="border-2 border-[--bg-d5]">
        <tr>
          <td className="border border-[--bg-d5] border-solid bg-[--bg] text-sm text-right py-2 px-4 w-40">
            250 {t("sendMessages")}
          </td>
          <td colspan="3" className="border border-[--bg-d5] border-solid text-center py-2 px-4">
            {t("included")}
          </td>
        </tr>
        <tr className="">
          <td className="border border-[--bg-d5] border-solid bg-[--bg] text-sm text-right py-2 px-4">1.000 {t("sendMessages")}</td>
          <td className="border border-[--bg-d5] border-solid text-center  py-2 px-4">
            € {priceFormat(prices[1000].basic)}
          </td>
          <td className="border border-[--bg-d5] border-solid text-center py-2 px-4">{t("included")}</td>
          <td className="border border-[--bg-d5] border-solid text-center py-2 px-4">{t("included")}</td>
        </tr>
        {[
          { messages: `2.000 ${t("sendMessages")}`, price: prices[2000].basic },
          { messages: `5.000 ${t("sendMessages")}`, price: prices[5000].basic },
        ].map((row) => (
          <tr>
            <td className="border border-[--bg-d5] border-solid bg-[--bg] text-sm text-right py-2 px-4">
              {row.messages}
            </td>
            <td colspan="3" className="border border-[--bg-d5] border-solid text-center py-2 px-4">
              € {priceFormat(row.price)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DailyMessagesPriceTable;
